import { useConfig } from '../../../context';
export const useIsWithSelectableCurrencies = () => {
    const { SearchForm: { selectableCurrencies } } = useConfig();
    return (selectableCurrencies === null || selectableCurrencies === void 0 ? void 0 : selectableCurrencies.length) > 1;
};
